import { render, staticRenderFns } from "./ClienteNuevo.vue?vue&type=template&id=59ed5dad&scoped=true&"
import script from "./ClienteNuevo.vue?vue&type=script&lang=js&"
export * from "./ClienteNuevo.vue?vue&type=script&lang=js&"
import style0 from "./ClienteNuevo.vue?vue&type=style&index=0&id=59ed5dad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed5dad",
  null
  
)

export default component.exports